export const PREOPERATIVE_TPA = [
  {
    _id: 0,
    sawRadius: "12mm",
    "15deg": "2.0",
    "16deg": "2.2",
    "17deg": "2.4",
    "18deg": "2.6",
    "19deg": "2.9",
    "20deg": "3.1",
    "21deg": "3.3",
    "22deg": "3.5",
    "23deg": "3.7",
    "24deg": "3.9",
    "25deg": "4.1",
    "26deg": "4.3",
    "27deg": "4.5",
    "28deg": "4.7",
    "29deg": "4.9",
    "30deg": "5.1",
    "31deg": "5.3",
    "32deg": "5.5",
    "33deg": "5.7",
    "34deg": "5.9",
    "35deg": "6.1",
    "36deg": "6.3",
    "37deg": "6.4",
    "38deg": "6.6",
    "39deg": "6.8",
    "40deg": "7.0"
  },
  {
    _id: 1,
    sawRadius: "15mm",
    "15deg": "2.6",
    "16deg": "2.8",
    "17deg": "3.1",
    "18deg": "3.3",
    "19deg": "3.6",
    "20deg": "3.8",
    "21deg": "4.1",
    "22deg": "4.3",
    "23deg": "4.6",
    "24deg": "4.9",
    "25deg": "5.1",
    "26deg": "5.4",
    "27deg": "5.6",
    "28deg": "5.9",
    "29deg": "6.1",
    "30deg": "6.4",
    "31deg": "6.6",
    "32deg": "6.9",
    "33deg": "7.1",
    "34deg": "7.4",
    "35deg": "7.6",
    "36deg": "7.9",
    "37deg": "8.1",
    "38deg": "8.4",
    "39deg": "8.6",
    "40deg": "8.8"
  },
  {
    _id: 2,
    sawRadius: "18mm",
    "15deg": "3.1",
    "16deg": "3.4",
    "17deg": "3.7",
    "18deg": "4.0",
    "19deg": "4.3",
    "20deg": "4.6",
    "21deg": "4.9",
    "22deg": "5.2",
    "23deg": "5.5",
    "24deg": "5.8",
    "25deg": "6.1",
    "26deg": "6.5",
    "27deg": "6.8",
    "28deg": "7.1",
    "29deg": "7.4",
    "30deg": "7.7",
    "31deg": "8.0",
    "32deg": "8.3",
    "33deg": "8.6",
    "34deg": "8.9",
    "35deg": "9.2",
    "36deg": "9.5",
    "37deg": "9.8",
    "38deg": "10.1",
    "39deg": "10.3",
    "40deg": "10.6"
  },
  {
    _id: 3,
    sawRadius: "21mm",
    "15deg": "3.6",
    "16deg": "4.0",
    "17deg": "4.3",
    "18deg": "4.7",
    "19deg": "5.0",
    "20deg": "5.4",
    "21deg": "5.8",
    "22deg": "6.1",
    "23deg": "6.5",
    "24deg": "6.8",
    "25deg": "7.2",
    "26deg": "7.5",
    "27deg": "7.9",
    "28deg": "8.3",
    "29deg": "8.6",
    "30deg": "9.0",
    "31deg": "9.3",
    "32deg": "9.7",
    "33deg": "10.0",
    "34deg": "10.4",
    "35deg": "10.7",
    "36deg": "11.1",
    "37deg": "11.4",
    "38deg": "11.8",
    "39deg": "12.1",
    "40deg": "12.4"
  },
  {
    _id: 4,
    sawRadius: "24mm",
    "15deg": "4.1",
    "16deg": "4.5",
    "17deg": "5.0",
    "18deg": "5.4",
    "19deg": "5.8",
    "20deg": "6.2",
    "21deg": "6.6",
    "22deg": "7.0",
    "23deg": "7.4",
    "24deg": "7.8",
    "25deg": "8.2",
    "26deg": "8.6",
    "27deg": "9.0",
    "28deg": "9.5",
    "29deg": "9.9",
    "30deg": "10.3",
    "31deg": "10.7",
    "32deg": "11.1",
    "33deg": "11.5",
    "34deg": "11.9",
    "35deg": "12.3",
    "36deg": "12.7",
    "37deg": "13.1",
    "38deg": "13.5",
    "39deg": "13.9",
    "40deg": "14.3"
  },
  {
    _id: 5,
    sawRadius: "27mm",
    "15deg": "4.7",
    "16deg": "5.1",
    "17deg": "5.6",
    "18deg": "6.0",
    "19deg": "6.5",
    "20deg": "7.0",
    "21deg": "7.4",
    "22deg": "7.9",
    "23deg": "8.4",
    "24deg": "8.8",
    "25deg": "9.3",
    "26deg": "9.7",
    "27deg": "10.2",
    "28deg": "10.6",
    "29deg": "11.1",
    "30deg": "11.6",
    "31deg": "12.0",
    "32deg": "12.5",
    "33deg": "12.9",
    "34deg": "13.4",
    "35deg": "13.8",
    "36deg": "14.3",
    "37deg": "14.7",
    "38deg": "15.2",
    "39deg": "15.6",
    "40deg": "16.1"
  },
  {
    _id: 6,
    sawRadius: "30mm",
    "15deg": "5.2",
    "16deg": "5.7",
    "17deg": "6.2",
    "18deg": "6.7",
    "19deg": "7.2",
    "20deg": "7.8",
    "21deg": "8.3",
    "22deg": "8.8",
    "23deg": "9.3",
    "24deg": "9.8",
    "25deg": "10.3",
    "26deg": "10.8",
    "27deg": "11.3",
    "28deg": "11.8",
    "29deg": "12.3",
    "30deg": "12.9",
    "31deg": "13.4",
    "32deg": "13.9",
    "33deg": "14.4",
    "34deg": "14.9",
    "35deg": "15.4",
    "36deg": "15.9",
    "37deg": "16.4",
    "38deg": "16.9",
    "39deg": "17.4",
    "40deg": "17.9"
  }
];

export const DEGREES = Array.from({ length: 26 }, (_, i) => i + 15);
